module.exports = __webpack_public_path__ + "static/media/Logo-Footer@2x.44cb9c0e.png";